import { SIZE_LG } from "../../helpers/constants";
import ModalWrapper from "../../helpers/modalWrapper";
import FormQuestionAnswerEditForm from "../ApplicationPolicy/formQuestionAnswerEditForm";

const AnswerEditModal = (props) => {
    const {
        closeEditQuestionAnswerModal,
        mapEditingQuestionOrFieldToEditingSetting,
        Store,
        workSourceOptions,
        openDeleteAnswerModal,
        opponentQuestions,
    } = props;

    return (
        <ModalWrapper
            isOpen={Store.questionAnswerModalOpen}
            onClose={closeEditQuestionAnswerModal}
            size={SIZE_LG}
            modalTestId={`edit-modal-${Store.questionAnswerForEdit.machineName}`}
            buttonTestId={`edit-modal-close-button-${Store.questionAnswerForEdit.machineName}`}
        >
            <FormQuestionAnswerEditForm
                {...props}
                questionAnswer={Store.questionAnswer}
                applicationUpdateAction={Store.applicationUpdateAction}
                question={Store.questionAnswerForEdit}
                opponent={Store.questionAnswerOpponent}
                medicalExpertFees={Store.questionAnswerMedicalExpertFees}
                editingSetting={mapEditingQuestionOrFieldToEditingSetting(Store.questionAnswerForEdit)}
                triggeredQuestions={Store.triggeredQuestionsToDisplay}
                workSourceOptions={workSourceOptions}
                isEditModalOpen={Store.questionAnswerModalOpen}
                openDeleteAnswerModal={openDeleteAnswerModal}
                opponentQuestions={opponentQuestions}
            />
        </ModalWrapper>
    )
};

export default AnswerEditModal;